/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCategoryControllerListQueryResponse } from "../../models/incidentAgentController/IncidentCategoryControllerList";

function getIncidentCategoryControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/incident-agent/categories` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/categories}
 */
export async function incidentCategoryControllerList(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCategoryControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentCategoryControllerListUrl().url.toString(), ... requestConfig })  
  return res.data
}